<template>
  <!-- Breadcrumbs -->
  <div class="breadcrumbs">
    <ul class="breadcrumbs__list">
      <li class="breadcrumbs__item">
        <a class="breadcrumbs__link" href="/">
          <img :alt="in18['page_home']" class="img" src="/shop/images/breadcrumbs-home-v1.svg">
        </a>
      </li>
      <li v-if="category.parents" v-for="parent in category.parents" class="breadcrumbs__item">
        <a :href="parent.link" :title="parent.title">
          {{ parent.title }}
        </a>
      </li>
    </ul>
  </div><!-- .breadcrumbs -->
</template>

<script>
export default {
  props: {
    in18:     Object,
    category: Object,
  },
};
</script>
